<template>
  <VueSelect2
    :placeholder="currentPlaceHolder()"
    v-model="selectedCode"
    :settings="select2Settings()"
    :disabled="disabled === true"
    @open="onOpen"
    @click="onOpen"
  />
</template>

<script>
import VModelMixin from "@/mixins/v-model.mixin";
import VueSelect2 from "vue3-select2-component";


export default {
  name: "ScrollSelect2",
  props: ['dataSource','nextDataFn', 'startSearchFn',
    'hasMoreDataFn', 'busy', 'disabled', 'placeholder', 'perPage'],
  mixins: [ VModelMixin ],
  components: {VueSelect2},
  methods: {
    select2Settings() {
      return {
        dropdownCssClass: 'ps_personal_account',
        dropdownPosition: 'below',
        containerCssClass: 'v-select2',
        language: {
          loadingMore: function() {
            return "Загрузка данных..."; // Тот самый текст "Load more..."
          },
          noResults: () => {
            return 'Нет результатов';
          },
          searching: () => {
            return 'Поиск...'
          }
        },
        ajax: {
          processResults: data => ({results: data, pagination: {more: this.hasMoreDataFn() && !this.busy}}),
          transport: async (params, success, failure) => {
            try {
              console.log("TRANSPORT",params.data._type);
              const isMore = params.data._type === 'query:append'; // Проверяем, это дозагрузка или новый поиск
              const oldLen = (this.dataSource || []).length;

              // Запускаем поиск/загрузку
              // Передаем признак дозагрузки в startSearchFn, если ваш метод это поддерживает
              const searchResult = await this.startSearchFn(params.data.term, isMore);

              if (!searchResult && !isMore) {
                success([]);
                return;
              }

              const allItems = this.dataSource || [];
              const formatted = allItems.map(item => ({
                id: item.id,
                text: item.text
              }));

              // Если это пагинация (скролл), отдаем только новые элементы
              // Если новый поиск (query), отдаем всё
              const resultsToReturn = isMore ? formatted.slice(oldLen) : formatted;
              console.log(resultsToReturn.length);
              success(resultsToReturn || []);
            } catch (err) {
              console.error('Select2 transport error:', err);
              failure(err);
            }
          }
        },
      }
    },
    onOpen() {
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      if (!isTouchDevice) {
        const e = document.querySelector('input.select2-search__field');
        if (e) e.focus();
      }
    },
    currentPlaceHolder() {
      const selItem = (this.dataSource || [])
          .find(item => (item.code || '').toString() === (this.selectedCode || '').toString());
      if (!selItem ) {
        if(!this.selectedCode) {
          return this.placeholder;
        }
        else {
          return this.selectedCode;
        }
      }
      return selItem.label;
    }
  },
  computed: {
    selectedCode: {
      get() {
        return String(this.currentValue);
      },
      set(value) {
        this.currentValue = String(value);
      }
    },

  }
}
</script>
<style scoped lang="scss">
</style>
